module.exports = __webpack_public_path__ + "img/buildingOperations.d9ec8416.svg";